<script setup lang="ts">
// Plan 2026-10-04 Task 3: Gold top strip, moved out of GoldSignalTab.vue.
// GoldSparklineBar self-polls, so `ctx` is accepted (uniform strip contract)
// and ignored.
import GoldSparklineBar from '../GoldSparklineBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'
defineProps<{ ctx: SignalTabCtx }>()
</script>
<template><GoldSparklineBar /></template>
